import { general } from './general'

export const actions = Object.assign({}, general)
